export function validateNewPassword(
  currentPassword: string,
  newPassword: string,
  confirmation: string,
): Record<string, string> {
  const errors: Record<string, string> = {};
  if (!currentPassword) errors.currentPassword = "Enter your current password.";
  const bytes = new TextEncoder().encode(newPassword).length;
  if (bytes < 12 || bytes > 72) {
    errors.newPassword = "Use 12–72 UTF-8 bytes for your new password.";
  } else if (newPassword === currentPassword) {
    errors.newPassword =
      "Choose a password different from your current password.";
  }
  if (confirmation !== newPassword || !confirmation) {
    errors.confirmation = "Passwords must match.";
  }
  return errors;
}
